import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QBOSubscriptionModalService extends BaseModalService<any> {
  readonly submitStatus$ = new Subject<any>();
  emitSubmitStatus(result: any) {
    this.submitStatus$.next(result);
  }
}
